import { useTranslation } from 'react-i18next';
import { isQuoteAwardable } from './quoteAwarding';
import { isOrderedOnSellerOffer, sellerOfferOrderBlock } from './sellerOffer';
import type { Quote } from './splitAwardGridTypes';

export function SellerOfferNotice({ quote }: Readonly<{ quote: Quote }>) {
  const { t } = useTranslation('rfq-view');

  if (!isQuoteAwardable(quote.status) || !isOrderedOnSellerOffer(quote)) {
    return null;
  }
  const orderBlock = sellerOfferOrderBlock(quote);
  if (orderBlock === 'no_seller_offer') {
    return null;
  }
  return (
    <span
      className="block text-xs font-normal text-neut-sec"
      data-testid={`seller-offer-notice-${quote.id}`}
    >
      {orderBlock === 'tally_offer_lines_missing'
        ? t('rfq_view.cannot_order_without_tally_offer_lines_label')
        : t('rfq_view.ordering_on_seller_offer_label')}
    </span>
  );
}
